export const init = () => {

  CUBE.Analytics = CUBE.Analytics || {};
  CUBE.Analytics.utils = Object.assign({}, CUBE.Analytics.utils, {
    es6: {

      //Comes from tag commander : Get real path to send to GA from document.location.pathname
      getRealPath: (path) => {
        const self = CUBE.Analytics.utils.es6;
        let result = path;
        let locale = `/${tc_vars.env_language}`;

        if (!self.containsString(`${locale}/`)) {
          locale = '';
        }

        result = self.getRealPathIfContainsString('/browse/') ||
          self.getRealPathIfContainsString('/sports-advice/category/') ||
          self.getRealPathIfContainsString('/product-details/') ||
          self.getRealPathIfContainsString('/p/');

        if (!result) { //Si c'est une recherche, on récupère le param
          if (path.indexOf(`${locale  }/search`) === 0) {
            const param = window.location.search && window.location.search.split('Ntt=')[1];
            result = `/search/${param}`;
          } else {
            result = path.split('/_')[0];
          }
        }

        return result.toLowerCase();
      },

      containsString: (path, string) => (path.indexOf(string) === 0),

      getRealPathIfContainsString: (path, string) => {
        const self = CUBE.Analytics.utils.es6;
        const locale = `/${tc_vars.env_language}`;
        let result = false;

        if (self.containsString(path, `${locale}${string}`)) {
          result = `/${path.split('/_/')[0].split(string)[1]}`;
          if (self.containsString(result, '/')) {
            result = result.split('/');
            result = `/${result[result.length - 1]}`;
          }
        }

        return result;
      },



      getProduct: element => {
        // Be sure to have a vanilla js element
        if (element.length) return element[0].closest('[data-modelId]');
        return element.closest('[data-modelId]');
      },

      /**
       * Replace the tc_vars and the custom dimension associated (only if prompted)
       * with the value in parameter
       *
       * @param value (string) The new value (ex : "product")
       * @param varName (string) The name of the tc_vars attribute to be replaced (ex : "env_template")
       * @param dimensionNumber (string) The number of the cd to be replaced (optionnal) (ex : "2")
       */
      reloadAnalyticsVariable: (value, varName, dimensionNumber) => {
        tc_vars[varName] = value;
        if (dimensionNumber && GAFramework) {
          GAFramework.setDimension(`cd${dimensionNumber}`, `dimension${dimensionNumber}`, value);
        }
      },

    }
  });

};



// WEBPACK FOOTER //
// ./src/analytics/framework/utils/utils-es6.js